module.exports = __webpack_public_path__ + "img/HelveticaNeueCyrRoman.e6385e9.svg";